import apiClient from "../api";

export const registerUser = async (userData) => {
  try {
    const response = await apiClient.post("gestock/register", userData
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const verifyOTP = async (phone, otp) => {
  try {
    const response = await apiClient.post("gestock/verify-otp", { phone, otp });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const requestOTP = async (phone) => {
  try {
    const response = await apiClient.post("gestock/request-otp", { phone });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const requestPasswordResetOTP = async (phone) => {
  try {
    const response = await apiClient.post("gestock/password-reset/request-otp", { phone });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const resetPasswordWithOTP = async ({ phone, otp, password }) => {
  try {
    const response = await apiClient.post("gestock/password-reset/reset", {
      phone,
      otp,
      newPassword: password,
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};


export const loginUser = async (userData) => {
  try {
    const response = await apiClient.post("gestock/login", userData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const acceptTerms = async (userId, acceptTerms) => {
  try {
    const response = await apiClient.post("auth/accept-terms", { userId, acceptTerms });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};
